var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUndefined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2580_65272)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66713 13.0011C6.51377 13.0011 6.35908 12.9484 6.23373 12.8404C5.95436 12.6011 5.92169 12.1803 6.16172 11.901L7.78995 10.0007L6.16172 8.10043C5.92236 7.82106 5.95436 7.40034 6.23373 7.16097C6.51244 6.92094 6.93383 6.95294 7.17386 7.23298L9.17414 9.56663C9.38817 9.816 9.38817 10.1847 9.17414 10.4341L7.17386 12.7677C7.04184 12.9224 6.85449 13.0011 6.66713 13.0011Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3343 13.0011H10.6672C10.2992 13.0011 10.0005 12.7031 10.0005 12.3344C10.0005 11.9657 10.2992 11.6676 10.6672 11.6676H13.3343C13.7023 11.6676 14.001 11.9657 14.001 12.3344C14.001 12.7031 13.7023 13.0011 13.3343 13.0011Z",
    fill: "#6C6C6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2580_65272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUndefined);
export default __webpack_public_path__ + "static/media/ic-undefined.28d2397c9087434f9ff90a108b67d61a.svg";
export { ForwardRef as ReactComponent };